import { ApiCopayRequest, ApiCopayResponse } from 'src/app/core/models';

/////////////////////////////////////////
// Forces Skip Billing Step when true:
const lowPatientResponsibility = false;
/////////////////////////////////////////

export const getCopay = (_: any, body: ApiCopayRequest): ApiCopayResponse => {
  const withResponsibility = {
    patientInfo: {
      balance: 50.0,
      hasPaymentPlan: false,
      hasRentalSchedule: false,
    },
    insurances: [{ insuranceType: 1 }, { insuranceType: 2 }],
    items: [{ item: { itemId: 1, quantity: 1, description: 'Test Item' } }],
    copay: {
      finalPatientAmount: 100.0,
      items: [
        {
          item: { itemId: 1 },
          total: 100,
          patientAmount: 100,
          primaryInsuranceAmount: 70,
          secondaryInsuranceAmount: 30,
          primaryReimbursementPercentage: 70,
          secondaryReimbursementPercentage: 30,
          remainingDeductibleBefore: 20,
          remainingSecondaryDeductibleBefore: 10,
        },
      ],
    },
    collectionExcluded: false,
    allowOverridePrimaryDeduct: true,
    allowOverrideSecondaryDeduct: true,
  };

  const applyDeductibleOverrides = {
    patientInfo: {
      balance: 50.0,
      hasPaymentPlan: false,
      hasRentalSchedule: false,
    },
    insurances: [{ insuranceType: 1 }, { insuranceType: 2 }],
    items: [{ item: { itemId: 1, quantity: 1, description: 'Test Item' } }],
    copay: {
      finalPatientAmount: 0,
      items: [
        {
          item: { itemId: 1 },
          total: 100,
          patientAmount: 100,
          primaryInsuranceAmount: 70,
          secondaryInsuranceAmount: 30,
          primaryReimbursementPercentage: 70,
          secondaryReimbursementPercentage: 30,
          remainingDeductibleBefore: 20,
          remainingSecondaryDeductibleBefore: 10,
        },
      ],
    },
    collectionExcluded: false,
    allowOverridePrimaryDeduct: true,
    allowOverrideSecondaryDeduct: true,
  };

  const lowResponsibility = {
    patientInfo: {
      balance: 3.2,
      hasPaymentPlan: false,
      hasRentalSchedule: false,
    },
    insurances: [{ insuranceType: 1 }, { insuranceType: 2 }],
    items: [{ item: { itemId: 1, quantity: 1, description: 'Test Item' } }],
    copay: {
      finalPatientAmount: 0.0,
      items: [
        {
          item: { itemId: 1 },
          total: 100,
          patientAmount: 100,
          primaryInsuranceAmount: 70,
          secondaryInsuranceAmount: 30,
          primaryReimbursementPercentage: 70,
          secondaryReimbursementPercentage: 30,
          remainingDeductibleBefore: 20,
          remainingSecondaryDeductibleBefore: 10,
        },
      ],
    },
    collectionExcluded: false,
    allowOverridePrimaryDeduct: true,
    allowOverrideSecondaryDeduct: true,
  };

  const isOverridingDeductible =
    body.overriddenPrimaryRemainingDeductible !== undefined ||
    body.overriddenSecondaryRemainingDeductible !== undefined;

  return isOverridingDeductible
    ? applyDeductibleOverrides
    : lowPatientResponsibility
    ? lowResponsibility
    : withResponsibility;
};
